import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Hidden from "@material-ui/core/Hidden";
import { Link } from "react-router-dom";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: 0,
    marginRight: 0,
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  // Do not touch
  appBarMain: {
    backgroundColor: "white",
    height: 80,
    padding: "10px 0px",
    boxShadow: theme.shadows[3],
    [theme.breakpoints.down("md")]: {
      padding: "10px 0px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "14px 0px",
    },
  },
  // Do not touch
  toolbar: {
    height: 60,
    margin: "0px 95px",
    [theme.breakpoints.down("md")]: {
      margin: "0px 32px",
    },
    padding: 0,
  },
  rightContainer: {
    position: "absolute",
    display: 'flex',
    flexDirection: "row",
    alignItems: 'center',
    // width:'100%',
    right: 0,
    [theme.breakpoints.down("md")]: {
      margin: "40px 20px",
      position: "static",
      width: "50vw",
      display: "flex",
      flexDirection: "column",
      color: "black",
    },
  },
  link: {
    position: "relative",
    textAlign: 'center',
    padding: "0px 2vw",//0vw
    color: "#FF5A34",
    fontSize: 16,
    fontWeight: "600",
    [theme.breakpoints.down("md")]: {
      color: "#606060",
      padding: 10,
      margin: "0 auto",
    },
    "&:hover": {
      color: "#FF5A34",
    },
  },
  logoLink: {
    position: "relative",
    padding: "0px 0px",//2vw
    color: "#E4223F",
    fontSize: 16,
    fontWeight: "600",
    "&:hover": {
      color: "#FF5A34",
    },
    textAlign: "left",
    width: "100%",
    // paddingLeft: "40px",
    [theme.breakpoints.down("md")]: {
      color: "#606060",
      padding: 10,
      margin: "0 auto 0 0",
      paddingLeft: "0px",
    },
  },
  linkItems: {
    backgroundColor: "#FF5A34", borderRadius: 100, alignItems: 'center', display: 'flex', height: 40, marginRight: 0, //32
    [theme.breakpoints.down("md")]: {
      border: 0, marginRight: 0,
    },
  },
  applyBtn: {
    padding: "10px 40px",
    border: "2px solid #FF5A34",
    backgroundColor: "#FF5A34",
    color: "#FFFFFF",
    font: "inherit",
    textTransform: "none",
    fontSize: 16,
    borderRadius: 30,
    [theme.breakpoints.down("md")]: {
      border: "2px solid #FF5A34",
      color: "#FFFFFF",
      margin: "10px 0px 10px 0px",
    },
    "&:hover": {
      opacity: 0.8,
      backgroundColor: "#FF5A34",
    },
  },
  // loginBtn: {
  //   border: '2px solid #FF5A34',
  //   backgroundColor: '#FF5A34',
  //   color: 'white',
  //   font: 'inherit',
  //   textTransform: 'none',
  //   fontSize: 16,
  //   borderRadius: 30,
  //   padding: '10px 40px',
  //   margin: '0px 20px',
  //   [theme.breakpoints.down('md')]: {
  //     backgroundColor: '#FF5A34',
  //     color: 'white',
  //     margin: "10px 0px 10px 30px",
  //   },
  // },
  arrowDown: {
    position: "absolute",
    top: -8,
    right: 0,
    fontSize: 20,
    padding: 10,
    [theme.breakpoints.down("md")]: {
      top: 2,
      right: -20,
    },
    "&:hover": {
      color: "#FF5A34",
    },
  },
  dropdown: {
    margin: "0px 14vw",
    padding: "10px 20px",
    position: "absolute",
    backgroundColor: "#FFFFFF",
    minWidth: "160px",
    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
    zIndex: 1,
  },
  menuItem: {
    padding: 0,
    height: 40,
  },
  dropdownLink: {
    padding: "10px 20px",
    width: "100%",
    color: "#606060",
    fontSize: 17,
    fontFamily: "Montserrat, Helvetica Neue, sans-serif",
    "&:hover": {
      color: "#FF5A34",
    },
  },
});

class NavBar extends React.Component {
  aboutUsButtonRef = null;

  state = {
    drawerOpen: false,
    isAboutUsDropdownOpen: false,
  };

  toggleDrawer = () => {
    this.setState((state) => {
      return {
        drawerOpen: !state.drawerOpen,
      };
    });
  };

  toggleDropdownOpen = (event) => {
    event.preventDefault();
    this.setState((prevState) => ({
      isAboutUsDropdownOpen: !prevState.isAboutUsDropdownOpen,
    }));
  };

  handleDropdownClose = (event) => {
    if (this.aboutUsButtonRef.contains(event.target)) {
      return;
    }

    this.setState({ isAboutUsDropdownOpen: false });
  };

  render() {
    const { classes } = this.props;
    const { drawerOpen } = this.state;

    const navLinks = (
      <div className={classes.rightContainer}>
        <div style={{ alignItems: 'center', display: 'flex', marginBottom: 16, marginTop: 16 }}>
          <Link
            to=""
            className={classes.link}
            style={{ padding: "0px 24px" }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/home";
            }}
          >
            Home
          </Link>
        </div>
        <div style={{ alignItems: 'center', display: 'flex', marginBottom: 16, marginTop: 16 }}>
          <Link
            to=""
            className={classes.link}
            style={{ padding: "0px 24px" }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/projects";
            }}
          >
            Project Portfolio
          </Link>
        </div>
        <div style={{ alignItems: 'center', display: 'flex', marginBottom: 16, marginTop: 16 }}>
          <Link
            to=""
            className={classes.link}
            style={{ padding: "0px 24px" }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/pokemon";
            }}
          >
            Pokémon
          </Link>
        </div>
        {/* <div style={{ alignItems: 'center', display: 'flex', marginBottom: 16, marginTop: 16 }}>
          <Link
            className={classes.link}
            style={{ padding: "0px 24px" }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/pokemon";
            }}
          >
            Projects
          </Link>
        </div> */}
        {/* <div style={{ alignItems: 'center', display: 'flex', marginBottom: 16, marginTop: 16 }}>
          <Link
            className={classes.link}
            style={{ padding: "0px 24px" }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "https://github.com/TehDrink/TehDrink.github.io";
            }}
          >
            Source Code
          </Link>
        </div> */}
      </div>
    );
    return (
      <div className={classes.root}>
        <AppBar position="fixed" className={classes.appBarMain}>
          <Toolbar className={classes.toolbar}>
            <Link
              to="/"
              className={classes.logoLink}
              style={{ width: 'fit-content', alignItems: 'flex-start' }}
            >
              {/* <p>WRO2021 Randomizer</p> */}
            </Link>
            <IconButton
              className={classes.menuButton}
              color="default"
              aria-label="Menu"
              onClick={this.toggleDrawer}
            >
              <MenuIcon />
            </IconButton>
            <Hidden mdDown>{navLinks}</Hidden>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={this.toggleDrawer}
            >
              <div tabIndex={0} role="button" onKeyDown={this.toggleDrawer}>
                {navLinks}
              </div>
            </Drawer>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NavBar);
